import { ElementProps } from '@/components/sections/builder/types';

import { useBuilderStore } from '@/stores/builder';
import React from 'react';
import { shallow } from 'zustand/shallow';
import TextEditorMinimal from '@/components/commons/minimal-tiptap/minimal-editor';
import InputSlider from '@/components/sections/builder/settings/input-slider';
import { FooterTextWithIconType } from '@/components/sections/builder/elements/footer/footer/types';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import ImageSetting from '@/components/sections/builder/settings/image-setting';
import { Plus } from 'lucide-react';

export default function ElementSetting({ element }: ElementProps) {
  const builder = useBuilderStore(
    (state) => ({
      setChildData: state.setChildData,
      clearSelected: state.clearSelected,
    }),
    shallow
  );

  const data = element.data as FooterTextWithIconType;

  const onChangeContent = (idx: number, key: string, val: string) => {
    const tempContents = [...data.contents];
    tempContents[idx] = {
      ...tempContents[idx],
      [key]: val,
    };
    builder.setChildData(element.parentId as string, element.id, {
      contents: tempContents,
    });
  };

  const onAddContent = () => {
    const tempContents = [...data.contents];
    tempContents.push({
      subHeading: 'Whatsapp Number',
      description: '+62 123-0000-1111',
    });
    builder.setChildData(element.parentId as string, element.id, {
      contents: tempContents,
    });
  };

  return (
    <div>
      <div className='mb-3'>
        <h3 className='mb-2'>Heading</h3>
        <TextEditorMinimal
          value={data.heading as string}
          onChange={(val) => {
            builder.setChildData(element.parentId as string, element.id, {
              heading: val,
            });
          }}
          output='html'
          editorProps={{
            attributes: {
              class: 'prose lg:prose-lg prose-blue dark:prose-invert p-2',
            },
          }}
          editable
        />
      </div>
      <div className='mb-2 mt-4'>Display Column per Row</div>
      <InputSlider
        value={data.columnPerRow || 0}
        min={1}
        max={2}
        onChange={(val) => {
          builder.setChildData(element.parentId as string, element.id, {
            columnPerRow: val,
          });
        }}
      />
      <Accordion type='single' collapsible defaultValue='item-0' className='w-full'>
        {data.contents?.map((content, idx) => (
          <AccordionItem value={`item-${idx}`} key={idx}>
            <AccordionTrigger>
              <p
                className='content-footer-text'
                dangerouslySetInnerHTML={{ __html: content.subHeading || '' }}
              ></p>
            </AccordionTrigger>
            <AccordionContent className='pl-4'>
              <div className='mb-3'>
                <h3 className='mb-2'>Icon</h3>
                <ImageSetting
                  value={content.iconUrl}
                  onChange={(val) => onChangeContent(idx, 'iconUrl', val as string)}
                />
              </div>
              <div className='mb-3'>
                <h3 className='mb-2'>Sub Heading</h3>
                <TextEditorMinimal
                  value={content.subHeading as string}
                  onChange={(val) => onChangeContent(idx, 'subHeading', val as string)}
                  output='html'
                  editorProps={{
                    attributes: {
                      class: 'prose lg:prose-lg prose-blue dark:prose-invert p-2',
                    },
                  }}
                  editable
                />
              </div>
              <div className='mb-3'>
                <h3 className='mb-2'>Description</h3>
                <TextEditorMinimal
                  value={content.description as string}
                  onChange={(val) => onChangeContent(idx, 'description', val as string)}
                  output='html'
                  editorProps={{
                    attributes: {
                      class: 'prose lg:prose-lg prose-blue dark:prose-invert p-2',
                    },
                  }}
                  editable
                />
              </div>
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
      <button
        type='button'
        onClick={onAddContent}
        className='flex w-full items-center justify-center gap-x-2 rounded-sm px-6 py-2 text-primary hover:bg-[#E9F7FF]'
      >
        <Plus className='h-4 w-4' />
        Add Content
      </button>
    </div>
  );
}
